// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".dvCustomAlert[data-v-4122e79a]{width:38vw;height:40vh;border-radius:2.1875rem;background-color:#f7f7f7}", ""]);
// Exports
module.exports = exports;
